import { 
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBBtn,
    MDBInput
 } from "mdb-react-ui-kit";
import React from "react";
import Swal from "sweetalert2";
import "./index.css"
const Login = () => {
    const login = (e) => {
        e.preventDefault()
        const {username , password} = e.target
        fetch(`${process.env.REACT_APP_URL}user/login`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user: username.value,
                pass: password.value
            })
        }).then(result => result.json())
        .then(data =>{
            console.log(data)
            if(data.message === "success"){
                localStorage.setItem('auth', JSON.stringify(data.data.username))
                Swal.fire({
                    title: "Login Successfully",
                    icon: "success",
                    text: `Welcome Admin`
                  }).then(result => {
                    if(result.isConfirmed){
                        window.location.href = '/dashboard/admin'
                    }
                    
                  })
            } else {
                Swal.fire({
                    title: "Authentication Failed",
                    icon: "info",
                    text: "Please Check your username and password"
                })
            }
        })
    }
    return(
    <MDBContainer fluid className="loginbg d-flex justify-content-center align-items-center min-vh-100">
    <MDBCard className="bg-primary text-white w-50">
    <form onSubmit={login}>
      <MDBCardBody>
        <MDBCardTitle>Login</MDBCardTitle>
        <MDBCardText>Username</MDBCardText>
        <MDBInput className="text-white" name="username">

        </MDBInput>
        <MDBCardText>Password</MDBCardText>
        <MDBInput type="password" className="text-white" name="password">
            
        </MDBInput>
        <MDBBtn type="submit" className="bg-success mt-3">Login</MDBBtn>
      </MDBCardBody>
      </form>
    </MDBCard>
    </MDBContainer>
    )
    
}

export default Login;